<svelte:options tag="mobile-menu" />

<div id="main" on:click={toggle} on:mouseover={iconMouseEnter} on:mouseleave={iconMouseLeave} class:hoverenabled>
  <!-- Mobile Menu 3 dot Icon -->
  <svg
    version="1.1"
    id="mobile-menu-icon"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="40px"
    height="40px"
    viewBox="0 0 64 512"
    style="overflow: visible; enable-background: new 0 0 64 512;"
    xml:space="preserve"
    aria-label="mobile menu icon"
    role="button"
  >
    <circle class="hover-ring trans" cx="80" cy="256" r="256" />
    <path
      class="st0"
      d="M32 224c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM0 136c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm0 240c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32z"
    />
  </svg>

  <div id="apps-list-w">
    <ul id="apps-list">
      {#if !user.uuid}<li class:hoverenabled>
          <a href={getAccessLoginUrl()}>LOGIN</a>
          <div class="indicator" />
        </li>{/if}
      {#if typeof userrequestprocessed === 'string'}
        <li class:hoverenabled>
          <a href={getAccessLoginUrl()}>Retry Login</a>
          <div class="indicator" />
        </li>
      {:else if userrequestprocessed && userloggedin}
        <li class:hoverenabled>
          <a href={accessProfileUrl}>
            {user.firstName}
            {user.lastName}
          </a>
          <div class="indicator" />
        </li>
        {#if user.uuid}
          <li class:hoverenabled>
            <a href={getAccessLogoutUrl()} title="Logout the current user">Logout</a>
            <div class="indicator" />
          </li>
        {/if}
        {#if userlinks.length > 0}
          {#each userlinks as link}
            <li class:hoverenabled>
              <a href={link.url}>{link.title}</a>
              <div class="indicator" />
            </li>
          {/each}
        {/if}
      {/if}
      <li class="divider"><hr /></li>
      {#each sites as site}
        <li class:hoverenabled class:active={current === site.name}>
          <a href={site.url} on:click={itemClicked(site.title)}>{site.title}</a>
          <div class="indicator" />
        </li>
      {/each}
    </ul>
  </div>
</div>

<script>
  import { onMount } from 'svelte'
  import { get_current_component } from 'svelte/internal'

  const isMobile = /Mobi|Android/.test(navigator.userAgent)
  const hoverenabled = !isMobile
  const component = get_current_component()

  let show = false
  let sites = [{ title: 'Loading...', url: '#', name: '' }]

  export let current = null
  export let appenv = 'prod'
  export let logoutredirecturl = null
  export let accessurl = 'access.ripe.net'
  export let pictureurl = null
  export let userloggedin = false
  export let userrequestprocessed = null // fake Option, { null || true || errorString}
  export let userlinks = []

  let showUserActions = false
  let user = { uuid: null }
  const usercookie = document.cookie.includes('crowd.ripe.hint')

  $: accessLoginUrl = (accessurl && accessurl.slice(0, 8) !== 'https://' && `https://${accessurl}`) || accessurl
  $: accessPictureUrl = pictureurl || `${accessLoginUrl}/picture/${user.uuid}`
  $: accessUserUrl = `${accessLoginUrl}/user/profile`
  $: accessProfileUrl = `${accessLoginUrl}/profile`
  $: userloggedin = userloggedin
  $: userrequestprocessed = userrequestprocessed

  $: if (accessLoginUrl && !userrequestprocessed && usercookie) {
    fetch(accessUserUrl, { credentials: 'include', cache: 'no-store' })
      .then(accessUserResponse => {
        if (accessUserResponse && accessUserResponse.status === 200) {
          userloggedin = true
          accessUserResponse.json().then(r => {
            userrequestprocessed = true
            user = r
          })
        } else {
          userrequestprocessed = userrequestprocessed || true
        }
      })
      .catch(e => {
        userloggedin = false
        userrequestprocessed = 'Login not available'
      })
  }

  const toggleUserActions = e => {
    // unhappy with this.
    // It is sort of used as a conditional branch
    // This function is sometimes called not as event callback,
    // but instead as a stand-alone function.
    // In that case there's no event data, of course
    if (e) {
      e.preventDefault()
    }
    if (!userloggedin) {
      window.location.href = getAccessLoginUrl()
      return
    }
    showUserActions = !showUserActions
    if (showUserActions) {
      return window.setTimeout(() => window.addEventListener('click', handleUserActionsClose), 0)
    }
    return window.removeEventListener('click', handleUserActionsClose)
  }

  const handleUserActionsClose = e => {
    const clickedElemInShadowDom = e.composedPath()[0]
    const canClickWhileOpen = clickedElemInShadowDom.classList.contains('clickable')
    if (canClickWhileOpen) {
      return
    }
    toggleUserActions()
  }

  const getAccessLoginUrl = () => {
    const currentUrl = window.location.href
    return `${accessLoginUrl}/?originalUrl=${encodeURI(currentUrl)}`
  }

  const getAccessLogoutUrl = () => {
    let redirectUrl = window.location.href
    if (logoutredirecturl) {
      redirectUrl = logoutredirecturl
    }
    return `${accessLoginUrl}/logout?originalUrl=${encodeURI(redirectUrl)}`
  }

  let iconHovered = false

  onMount(() => {
    fetch(`https://www-static.ripe.net/dynamic/app-switcher/${appenv === 'pre' ? 'pre-' : ''}list.json`)
      .then(response => response.json())
      .then(json => {
        sites = json
      })
  })

  function toggle() {
    show = !show
    if (show) {
      return window.setTimeout(() => window.addEventListener('mouseout', handleClose), 0)
    }
    return window.removeEventListener('mouseout', handleClose)
  }

  function handleClose(e) {
    const clickedElemInShadowDom = e.composedPath()[0]
    const canClickWhileOpen = clickedElemInShadowDom.classList.contains('clickable')
    if (canClickWhileOpen) {
      return
    }
    toggle()
  }

  function iconMouseEnter() {
    if (!iconHovered) {
      dispatch('mobile-menu-mouse-enter')
      iconHovered = true
    }
  }

  function iconMouseLeave() {
    iconHovered = false
    dispatch('mobile-menu-mouse-leave')
  }

  function itemClicked(title) {
    dispatch('mobile-menu-item-click', { item: title })
  }

  function dispatch(eventName, eventDetails = null) {
    const event = new CustomEvent(eventName, {
      bubbles: true,
      cancelable: true,
      composed: true,
    })
    if (eventDetails) {
      event.details = eventDetails
    }
    component.dispatchEvent(event)
  }
</script>

<style type="text/scss">
  :host {
    // @media only screen and (max-width: 700px) {
    //   height: 32px;
    //   width: 32px;
    // }

    width: 40px;
    height: 40px;
    position: relative;
    background: none;
    user-select: none;
    // pff, this should gap on the parent.
    // but chromium can't deal with it yet.
    margin-left: 1rem;
    font-family: var(--ripe-app-font-family), Helvetica, Arial, Sans-serif;
    font-weight: 600;
  }

  #main {
    position: relative;
    user-select: none;
    cursor: pointer;
    text-align: center;
    @media print {
      display: none;
    }
    li.divider hr {
      border-bottom: 2px solid var(--ripe-app-navbar-indicator, #f59331);
      display: block;
      margin: 0;
      padding: 0;
    }
    .st0 {
      fill: var(--ripe-app-header-icon-bg, #c0c0c0);
    }
    &:hover .st0 {
      fill: var(--ripe-app-navbar-background, #c0c0c0);
    }
    &:hover circle.hover-ring {
      stroke: none;
      opacity: 0.3;
      fill: var(--ripe-app-header-icon-hover, #080037);
      transform: scale(1.25);
      transform-origin: 256px 256px;
      transition: 0.1s transform ease-in;
    }

    &.hoverenabled:hover div#apps-list-w {
      display: block;
    }

    button {
      padding: 0;
      background: 0;
      border: 0;
    }

    &:hover div#apps-list-w {
      display: block;
    }
  }

  #mobile-menu-icon {
    // @media only screen and (max-width: 700px) {
    //   height: 32px;
    //   width: 32px;
    // }

    width: 5px;
    height: 40px;

    circle.hover-ring {
      fill: none;
      stroke: none;
    }

    &:hover {
      cursor: pointer;
    }
  }

  div#apps-list-w.show {
    display: block;
  }

  #apps-list-w {
    display: none;
    position: absolute;
    /* the safety hover-overlap starts
    working below 'top' */
    top: 25px;
    right: -2.5px;
    width: 190px;
  }

  #apps-list {
    background-color: var(--ripe-app-navbar-background, #080037);
    z-index: 999999;
    list-style: none;
    padding: 0;
    margin: 0;
    margin-top: 30px;

    &:after {
      top: 10px;
      right: 13px;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-bottom-color: var(--ripe-app-navbar-background, #080037);
      border-width: 10px;
      margin-left: -10px;
    }

    li {
      position: relative;
      list-style: none;
      text-align: left;
      border-bottom: 1px solid var(--ripe-app-border-line, #2f2c56);

      &.hoverenabled {
        &:hover {
          a {
            color: var(--ripe-app-navbar-menuitem, #d7dce8);
          }
          .indicator {
            opacity: 0.6;
            width: 6px;
          }
        }
      }

      &.active,
      &.active:hover {
        a {
          color: var(--ripe-app-navbar-active-menuitem, #ffffff);
        }
        .indicator {
          opacity: 1;
          width: 6px;
        }
      }

      a {
        color: var(--ripe-app-primary-20, #d7dce8);
        display: block;
        text-decoration: none;
        padding: 12px 16px 12px 20px;
      }

      .indicator {
        position: absolute;
        top: 0;
        left: 0;
        content: '';
        width: 0px;
        // because of border
        height: calc(100% + 1px);
        background: var(--ripe-app-navbar-indicator, #f59331);
        margin-bottom: 10px;
      }
    }
  }
</style>
